import { injectGlobal } from "styled-components";
import { colors } from "../stylesheet";

export default () => injectGlobal`
  html, body, #root {
    height: 100%;
  }
  .brand {
    color: ${colors.brand};
  }
  .bg-brand {
    background-color: ${colors.brand};
  }
`;



// WEBPACK FOOTER //
// ./src/core/bootstrap/stylesheet.js